import { useEffect, useState } from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import SocialLinks from "./components/SocialLinks";
import Work from "./components/Work";
import Footer from "./components/Footer";
import { items as navLinks } from "./data/headerItems.js";

function App() {
  const [isTopOfPage, setIsTopOfPage] = useState();

  const [activeSection, setActiveSection] = useState("home");

  const handleScroll = () => {
    if (window.scrollY === 0) {
      setIsTopOfPage(true);
    }
    if (window.scrollY !== 0) setIsTopOfPage(false);
  };

  const checkActiveSection = () => {
    let currentSection = "";
    const sectionElements = document.querySelectorAll("section");

    sectionElements.forEach((sectionElement) => {
      if (window.scrollY >= sectionElement.offsetTop - 200) {
        currentSection = sectionElement.id;
      }
    });

    navLinks.forEach((navLink) => {
      if (navLink.name === currentSection) {
        setActiveSection(currentSection);
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("scroll", checkActiveSection);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", checkActiveSection);
    };
  }, []);
  return (
    <div>
      <Navbar
        isTopOfPage={isTopOfPage}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <Home />
      <SocialLinks />
      <About />
      <Skills />
      <Work />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;

//here selected section can also be handled using state & passed as props

//defined isSelected state because in the future based upon which page is visible we have to set active nav page
